import React, { Component } from 'react';
import { toastr } from 'react-redux-toastr';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { isDirty } from 'redux-form';

import {
  validateForm,
  getFormById,
  getFormPdf,
  resetPdfDownloads,
  getPdfView,
  showAccountWithholdingModal,
  hideAccountWithholdingModal,
  showFormOverrideModal,
  hideFormOverrideModal,
  showCancelFormOverrideModal,
  hideCancelFormOverrideModal,
  acceptFormOverride,
  cancelFormOverride,
  showImyTreeWithholding,
  getStorageSetting,
  hideEditAddressModal,
  getStockMarkets,
  hideWhsDiscrepanciesModal,
  saveFormReviewState,
} from 'actions';

import EditAddressModal from 'components/Modals/EditAddressModal';
import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';
import LoadingWrapper from 'components/Common/LoadingWrapper';
import BlankPage from 'components/Blanks/BlankPage';
import RedirectButton from 'components/Common/Buttons/RedirectButton';
import NotFoundPage from 'components/Errors/NotFoundPage';
import ScrollPdfViewer from 'components/ScrollPdfViewer';
import FormReviewPanel from 'components/FormReviewPanel';
import FormWorkflowStages from 'common/Workflows/FormWorkflowStages';
import withContainerErrorBoundary from 'components/ErrorBoundaries/ContainerErrorBoundary/withContainerErrorBoundary';
import QueryParams from 'common/App/QueryParams';
import SplitButton from 'components/Common/Buttons/SplitButton';
import WhsDiscrepanciesModal from 'components/Modals/WhsDiscrepanciesModal';

import {
  normalizeUcrsValuesOnSave,
  normalizeUcrsInitialValuesOnLoad
} from 'components/Blanks/Shared/UCRS/UcrsAddressNormalization';

import {
  AsyncBlankBene,
  AsyncBlankBeneChanges,
  AsyncBlankBene2017,
  AsyncBlankBene2017Changes,
  AsyncBlankBene2021,
  AsyncBlankBene2021Changes,
  AsyncBlankBen,
  AsyncBlankBenChanges,
  AsyncBlankBen2014,
  AsyncBlankBen2014Changes,
  AsyncBlankBen2021,
  AsyncBlankBen2021Changes,
  AsyncBlankEci,
  AsyncBlankEciChanges,
  AsyncBlankEci2017,
  AsyncBlankEci2017Changes,
  AsyncBlankEci2021,
  AsyncBlankEci2021Changes,
  AsyncBlankExp,
  AsyncBlankExpChanges,
  AsyncBlankExp2017,
  AsyncBlankExp2017Changes,
  AsyncBlankExp2023,
  AsyncBlankExp2023Changes,
  AsyncBlankImy,
  AsyncBlankImyChanges,
  AsyncBlankImy2017,
  AsyncBlankImy2017Changes,
  AsyncBlankImy2021,
  AsyncBlankImy2021Changes,
  AsyncBlankW9,
  AsyncBlankW9Changes,
  AsyncBlankW92017,
  AsyncBlankW92017Changes,
  AsyncBlankW92018,
  AsyncBlankW92018Changes,
  AsyncBlankW92024,
  AsyncBlankW92024Changes,
  AsyncBlankCrse,
  AsyncBlankCrseChanges,
  AsyncBlankUCrse2025,
  AsyncBlankCrseBba,
  AsyncBlankCrsCp,
  AsyncBlankCrsCpChanges,
  AsyncBlankUCrsCp2025,
  AsyncBlankCrsi,
  AsyncBlankCrsiChanges,
  AsyncBlankUCrsi,
  AsyncBlankUCrsiChanges,
  AsyncBlankCrsi2024,
  AsyncBlankCrsi2024Changes,
  AsyncBlankRc519,
  AsyncBlankRc519Changes,
  AsyncBlankRc5192024,
  AsyncBlankRc5192024Changes,
  AsyncBlankRc5192025,
  AsyncBlankRc5192025Changes,
  AsyncBlankRc518,
  AsyncBlankRc518Changes,
  AsyncBlankRc5182024,
  AsyncBlankRc5182024Changes,
  AsyncBlankRc5182025,
  AsyncBlankRc5182025Changes,
  AsyncBlankFatcaCrsE2022,
  AsyncBlankFatcaCrsI2022,
  AsyncBlankFatcaCrsE2023,
  AsyncBlankFatcaCrsE2023Changes,
  AsyncBlankFatcaCrsI2023,
  AsyncBlankFatcaCrsI2023Changes,
  AsyncBlankUCarfI2026,
  AsyncBlankUCarfI2026Changes,
  AsyncBlankUCarfE2026,
  AsyncBlankUCarfE2026Changes,
  AsyncBlankUCarfCp2026
} from './asyncBlanks';

const ucrsNormalizationOptions = {
  ucrse_2025: { mailingAddressesArrayKey: 'mailingAddresses', headOfficeAddressKey: 'headOfficeAddress', partnerAddressKey: 'partnerAddress' },
  ucrscp_2025: { mailingAddressKey: 'mailingAddress' },
  ucrsi_2025: { mailingAddressKey: 'mailingAddress' },
  ucarfe_2026: { mailingAddressesArrayKey: 'mailingAddresses', headOfficeAddressKey: 'headOfficeAddress', partnerAddressKey: 'partnerAddress' },
  ucarfcp_2026: { mailingAddressKey: 'mailingAddress' },
  ucarfi_2026: { mailingAddressKey: 'mailingAddress' }
};

class BlankContainer extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    permissions: PropTypes.arrayOf(PropTypes.string),
    isValidatingForm: PropTypes.bool.isRequired,
    validationResult: PropTypes.shape(),
    match: PropTypes.shape().isRequired,
    isGettingFormById: PropTypes.bool.isRequired,
    isFetchingPdfForm: PropTypes.bool,
    isFetchingPdfView: PropTypes.bool,
    instructionToggled: PropTypes.string,
    ignoreDirtyTaxForm: PropTypes.bool,
    // eslint-disable-next-line
    pdfFile: PropTypes.shape(),
    pdfDownloads: PropTypes.arrayOf(PropTypes.shape()),
    // eslint-disable-next-line
    viewPdfData: PropTypes.any,
    formByIdError: PropTypes.shape({
      code: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ]),
      message: PropTypes.string
    }),
    formByIdResponse: PropTypes.shape(),
    getPdfViewError: PropTypes.shape({
      code: PropTypes.number,
      message: PropTypes.string
    }),
    formReviewState: PropTypes.shape(),
    workflowState: PropTypes.shape(),
    dirty: PropTypes.bool,
    forms: PropTypes.arrayOf(PropTypes.shape()),
    history: PropTypes.shape({
      go: PropTypes.func,
      block: PropTypes.func
    }).isRequired,
    location: PropTypes.shape({
      search: PropTypes.string
    }).isRequired,
    tinMatchFormProps: PropTypes.shape({
      tin: PropTypes.shape(),
      name: PropTypes.string
    }),
    isEditAddressModalShown: PropTypes.bool,
    isPiiProtectionEnabled: PropTypes.bool,
    stockMarkets: PropTypes.arrayOf(PropTypes.shape()),
    isWhsDiscrepanciesModalShown: PropTypes.bool,
    whsFormDiscrepancies: PropTypes.shape({
      coverageGapDetected: PropTypes.bool,
      effectiveToAdjustmenstRequired: PropTypes.bool,
      futureDatedWhsDetected: PropTypes.bool,
      linkedAccountsDetected: PropTypes.bool,
      whsAccountRequirementChanged: PropTypes.bool
    }),
    formReviewStateParameters: PropTypes.shape()
  };

  static defaultProps = {
    permissions: null,
    validationResult: null,
    formByIdResponse: null,
    formByIdError: null,
    isFetchingPdfForm: false,
    isFetchingPdfView: false,
    pdfFile: null,
    pdfDownloads: [],
    viewPdfData: null,
    getPdfViewError: null,
    instructionToggled: null,
    ignoreDirtyTaxForm: false,
    formReviewState: null,
    workflowState: null,
    dirty: false,
    forms: null,
    tinMatchFormProps: null,
    isEditAddressModalShown: false,
    isPiiProtectionEnabled: false,
    stockMarkets: null,
    isWhsDiscrepanciesModalShown: false,
    whsFormDiscrepancies: null,
    formReviewStateParameters: null
  };

  static resizeTimer;

  static updateFormDimensions() {
    if (BlankContainer.resizeTimer) {
      clearInterval(BlankContainer.resizeTimer);
      BlankContainer.resizeTimer = null;
    }
    BlankContainer.resizeTimer = setInterval(() => {
      if (window.innerWidth < 1000) {
        toastr.info('You should use a monitor with a screen resolution higher than 1000 pixels to best view these forms.');
      }
      BlankContainer.adjustFormContainerHeight();
    }, 1000, this);
  }

  static adjustFormContainerHeight() {
    clearInterval(BlankContainer.resizeTimer);
    BlankContainer.resizeTimer = null;

    let height = 0;

    if (!document.getElementById('form-content')
    || !document.getElementById('form-content').firstChild
    || !document.getElementById('blankForm')) {
      return;
    }
    const pages = document.getElementById('form-content').firstChild.childNodes;

    if (!pages || pages.length === 0) {
      return;
    }

    let top = 0;
    let bottom = 0;
    for (let i = 0; i < pages.length; i += 1) {
      if (pages[i].className.includes('page')) {
        if (top === 0) {
          top = Math.ceil(pages[i].getBoundingClientRect().top);
        }
        bottom = Math.ceil(pages[i].getBoundingClientRect().bottom);
      }
    }

    if (top === 0 || bottom === 0) {
      return;
    }

    height = bottom - top;

    document.getElementById('form-content').style.height = `${ height }px`;
  }

  static downloadFile(file) {
    const link = document.createElement('a');
    link.href = file.blob;
    link.setAttribute('download', (file.name) ? file.name : 'form.pdf');
    document.body.appendChild(link);
    link.click();
  }

  constructor(props) {
    super(props);

    const query = QueryParams.parse(props.location.search);
    this.toggleOriginal = this.toggleOriginal.bind(this);
    this.getPdfFile = this.getPdfFile.bind(this);

    this.state = {
      validationResultsVisible: true,
      originalVisible: false,
      pdfBlocked: false,
      pdfDownload: null,
      pdfView: null,
      showDocumentSignNotif: false,
      shownDocumentSignNotif: false,
      initialAccount: query && query.account && !Number.isNaN(query.account) ? parseInt(query.account, 10) : null
    };

    this.unblock = props.history.block((location, action) => {
      const { dirty, ignoreDirtyTaxForm } = this.props;
      const { shownDocumentSignNotif } = this.state;
      if (shownDocumentSignNotif) {
        return null;
      }
      if (dirty && !ignoreDirtyTaxForm) {
        return 'Are you sure you want to leave this page?';
      }
      return null;
    });

    this.onUnload = this.onUnload.bind(this);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    const { params: { blankType, formId } } = match;
    dispatch(getFormById(blankType, formId));

    window.addEventListener('resize', BlankContainer.updateFormDimensions);
    window.addEventListener('beforeunload', this.onUnload);
  }

  /* eslint-disable-next-line camelcase */
  UNSAFE_componentWillReceiveProps(newProps) {
    const {
      dispatch,
      isGettingFormById,
      isValidatingForm,
      isFetchingPdfForm,
      isFetchingPdfView,
      match,
      instructionToggled,
    } = this.props;
    const { validationResultsVisible, showDocumentSignNotif } = this.state;
    const { params: { blankType, formId } } = newProps.match;

    if (match.url !== newProps.match.url) {
      dispatch(getFormById(blankType, formId));
      dispatch(resetPdfDownloads());
      return;
    }

    if (isGettingFormById) {
      this.setState({
        validationResultsVisible: (newProps.validationResult != null && newProps.validationResult.result != null),
        originalVisible: false,
        pdfView: null,
        pdfDownload: null
      });
    }

    if (newProps.instructionToggled && newProps.instructionToggled !== instructionToggled) {
      BlankContainer.updateFormDimensions();
    }

    if (isValidatingForm) {
      const isVisible = (newProps.validationResult != null
        && newProps.validationResult.result != null);
      this.setState({
        validationResultsVisible: validationResultsVisible || isVisible
      });
    }

    if (!showDocumentSignNotif
      && newProps.formByIdResponse != null && newProps.formByIdResponse.isOnlineForm
      && newProps.validationResult != null) {
      const instrFound = newProps.validationResult.result[0] != null
        && newProps.validationResult.result[0].warnings != null
        && newProps.validationResult.result[0].rejections != null
        && newProps.validationResult.result[0].rejections.length === 0
        && (((blankType === 'w9' || blankType === 'w9_2017' || blankType === 'w9_2018') && newProps.validationResult.result[0].warnings.findIndex(el => el.code === 'REC000240') !== -1)
        || ((blankType === 'w8bene' || blankType === 'w8bene_2017' || blankType === 'w8bene_2021') && newProps.validationResult.result[0].warnings.findIndex(el => el.code === 'REC000890') !== -1));

      if (instrFound) {
        this.setState({
          showDocumentSignNotif: true
        });
      }
    }

    if (isFetchingPdfForm && !newProps.isFetchingPdfForm && newProps.pdfFile) {
      this.setState({
        pdfDownload: newProps.pdfFile.blob
      });
      BlankContainer.downloadFile(newProps.pdfFile);
    } else {
      this.setState({
        pdfDownload: null
      });
    }

    if (newProps?.viewPdfData && !newProps.getPdfViewError) {
      if (isFetchingPdfView && !newProps.isFetchingPdfView && newProps.viewPdfData) {
        this.setState({
          originalVisible: true,
          pdfView: newProps.viewPdfData
        });
      } else if (isFetchingPdfView && !newProps.isFetchingPdfView && newProps.viewPdfData == null) {
        toastr.confirm('The original form is too large to be displayed next to the digitized form. To view it, please download it using the \'Download original PDF\' button', { disableCancel: true });
        this.setState({ pdfBlocked: true });
      }
    }
  }

  componentDidUpdate() {
    BlankContainer.updateFormDimensions();
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    const { pdfDownload, pdfView } = this.state;
    window.removeEventListener('resize', BlankContainer.updateFormDimensions);

    dispatch(resetPdfDownloads());

    if (pdfDownload) {
      URL.revokeObjectURL(pdfDownload);
    }

    if (pdfView) {
      URL.revokeObjectURL(pdfView);
    }

    this.unblock();
    window.removeEventListener('beforeunload', this.onUnload);
  }

  onUnload(event) {
    const { dirty } = this.props;
    if (dirty != null && dirty) {
      event.returnValue = 'Are you sure you want to leave this page?';
    }
  }

  onValidateForm(blankType, values) {
    const { dispatch, match, isValidatingForm } = this.props;
    const { params: { formId } } = match;

    if (!isValidatingForm) {
      const ucrsNormalization = ucrsNormalizationOptions[blankType];
      const savedValues = ucrsNormalization != null
        ? normalizeUcrsValuesOnSave(values, ucrsNormalization)
        : values;
      const formValuesForDisplay = ucrsNormalization != null
        ? normalizeUcrsInitialValuesOnLoad(savedValues, ucrsNormalization)
        : savedValues;

      dispatch(validateForm(blankType, formId, savedValues, formValuesForDisplay));
    }
  }

  onFormReviewCollapseExpand(value) {
    this.setState({ validationResultsVisible: value });
  }

  onConfirmFormOverride(data) {
    const { dispatch, match: { params: { formId } } } = this.props;
    if (data) {
      dispatch(acceptFormOverride(formId, data));
    } else {
      this.onCancelFormOverride();
    }
  }

  onCancelFormOverride() {
    const { dispatch, match: { params: { formId } } } = this.props;
    dispatch(cancelFormOverride(formId));
  }

  getBlankComponent(BlankComponent, ChangesBlankComponent) {
    const { dispatch, stockMarkets, match: { params: { blankType } } } = this.props;
    if (this.usesStockMarketsDropdown() && !(stockMarkets && stockMarkets.length)) {
      dispatch(getStockMarkets());
    }
    return (
      <React.Suspense fallback={ <BlankPage><LoadingWrapper loaded={ false } /></BlankPage> }>
        <BlankComponent
          onSubmit={ values => this.onValidateForm(blankType, values) }
          formType={ blankType }
        />
        { ChangesBlankComponent && <ChangesBlankComponent
          formType={ `${ blankType }-changes` }
        /> }
      </React.Suspense>
    );
  }

  getPdfFile(file) {
    const { dispatch, pdfDownloads } = this.props;

    if (!file || !file.id || !file.originalFileName) {
      toastr.error('', 'There is no original pdf file stored with this form');
      return;
    }

    if (pdfDownloads && pdfDownloads.length > 0) {
      const matchingDownloads = pdfDownloads.filter(x => x.id === file.id);
      if (matchingDownloads?.length > 0) {
        BlankContainer.downloadFile(matchingDownloads[0]);
        return;
      }
    }

    dispatch(getFormPdf(file));
  }

  getOriginalPdfView(file) {
    const { dispatch, pdfDownloads } = this.props;
    const { pdfView } = this.state;

    if (pdfDownloads && pdfDownloads.length > 0) {
      const matchingDownloads = pdfDownloads.filter(x => x.id === file.id);
      if (matchingDownloads?.length > 0) {
        this.setState({ pdfView: matchingDownloads[0].blob, originalVisible: true });
        return;
      }
    }

    if (!pdfView) {
      dispatch(getPdfView(file));
    }
  }

  getWrapperClasses(blankType) {
    const { originalVisible, validationResultsVisible } = this.state;
    let classes = 'blank-wrapper';

    classes += blankType && blankType.indexOf('w') === 0 ? ' w-blank-wrapper' : '';
    classes += blankType && (blankType.indexOf('dt_crs') === 0 || blankType.indexOf('crs') === 0 || blankType.indexOf('ucrs') === 0) ? ' crs-blank-wrapper' : '';
    classes += blankType && blankType.indexOf('ucarf') === 0 ? ' carf-blank-wrapper' : '';
    classes += blankType && blankType.indexOf('rc') === 0 ? ' rc-blank-wrapper' : '';
    classes += blankType && blankType.indexOf('fatca_crs') === 0 ? ' fatca-crs-blank-wrapper' : '';

    classes += originalVisible ? ' side-by-side' : '';
    classes += originalVisible && !validationResultsVisible ? ' val-collapsed' : '';

    return classes;
  }

  getFormSectionClasses() {
    const { validationResultsVisible, originalVisible } = this.state;
    return `form-section ${ !originalVisible && !validationResultsVisible ? 'expand' : '' }`;
  }

  getValidationResultsSectionClasses() {
    const { validationResultsVisible } = this.state;
    return `validation-results-wrapper ${ !validationResultsVisible ? 'hide-content' : '' }`;
  }

  getFormContentClasses() {
    const { permissions } = this.props;

    if (permissions === null) {
      return 'form-content';
    }

    if (this.isWorkflowComplete() || this.isViewOnlyForm()) {
      return 'form-content view-only';
    }
    return 'form-content';
  }

  usesStockMarketsDropdown() {
    const { match: { params: { blankType } } } = this.props;
    if (blankType === 'w8bene'
      || blankType === 'w8bene_2017'
      || blankType === 'w8bene_2021'
      || blankType === 'w8imy'
      || blankType === 'w8imy_2017'
      || blankType === 'w8imy_2021'
      || blankType === 'crse'
      || blankType === 'ucrse_2025'
      || blankType === 'ucarfe_2026'
      || blankType === 'fatca_crse_2022'
      || blankType === 'fatca_crse_2023') {
      return true;
    }
    return false;
  }

  isValidated() {
    const { validationResult } = this.props;
    return (validationResult != null && validationResult.result != null);
  }

  isLocked() {
    const { validationResult } = this.props;
    return (validationResult && validationResult.result && validationResult.result[0] && validationResult.result[0].isLocked);
  }

  isWorkflowBatchStaging() {
    const { formReviewState } = this.props;
    return (formReviewState && formReviewState.workflowStage === FormWorkflowStages.BatchStaging);
  }

  isWorkflowComplete() {
    const { formReviewState } = this.props;
    return (formReviewState != null && formReviewState.workflowStage === FormWorkflowStages.Complete);
  }

  isValidReviewer() {
    const { permissions, formReviewState, workflowState } = this.props;

    if (formReviewState == null) {
      return false;
    }

    // WF Stage 1 or 2 - Draft or Pending Signature
    if (formReviewState.workflowStage === FormWorkflowStages.Draft || formReviewState.workflowStage === FormWorkflowStages.PendingSignature) {
      return true;
    }

    // WF Stage 3 - Batch Staging
    if (formReviewState.workflowStage === FormWorkflowStages.BatchStaging) {
      return false;
    }

    const isUserFormOwner = workflowState != null && workflowState.assignedUser === getStorageSetting('username');

    // WF Stage 4 or 5 and Initial Reviewer
    // WF Stage 6 or 7 and Secondary Reviewer
    // WF Stage 8, 9 or 100 and Expert Reviewer
    // WF Stage 100 and Supplementary Reviewer
    const initialReviewer = (formReviewState.workflowStage === FormWorkflowStages.PendingReview || formReviewState.workflowStage === FormWorkflowStages.UnderInitialReview)
      && AccessControl.hasPermission(permissions, [ActivityPerms.fwfInitialReviewer]);
    const secondaryReviewer = (formReviewState.workflowStage === FormWorkflowStages.PendingSecondaryReview || formReviewState.workflowStage === FormWorkflowStages.UnderSecondaryReview)
      && AccessControl.hasPermission(permissions, [ActivityPerms.fwfSecondaryReviewer]);
    const expertReviewer = (formReviewState.workflowStage === FormWorkflowStages.PendingExpertReview || formReviewState.workflowStage === FormWorkflowStages.UnderExpertReview || formReviewState.workflowStage === FormWorkflowStages.Complete)
      && AccessControl.hasPermission(permissions, [ActivityPerms.fwfExpertReviewer]);
    const suppReviewer = formReviewState.workflowStage === FormWorkflowStages.Complete && AccessControl.hasPermission(permissions, [ActivityPerms.fwfSupplReviewer]);

    if (formReviewState.workflowStage === FormWorkflowStages.Complete) {
      return (expertReviewer || suppReviewer);
    }

    return (isUserFormOwner && (initialReviewer || secondaryReviewer || expertReviewer || suppReviewer));
  }

  isOnlineForm() {
    const { formByIdResponse } = this.props;
    return (formByIdResponse != null && (formByIdResponse.isOnlineForm || !formByIdResponse.originalFileName));
  }

  isViewOnlyForm() {
    const { permissions, formReviewState, workflowState } = this.props;

    if (permissions === null) {
      return false;
    }

    if (this.isLocked()) {
      return true;
    }

    if (formReviewState == null || formReviewState.workflowStage === FormWorkflowStages.BatchStaging) {
      return true;
    }

    const isUserFormOwner = workflowState != null && workflowState.assignedUser === getStorageSetting('username');

    if (this.isOnlineForm()) {
      if (!isUserFormOwner || !AccessControl.hasPermission(permissions, [ActivityPerms.electronicValidate])) {
        return true;
      }
      return !AccessControl.hasPermission(permissions, [ActivityPerms.electronicView, ActivityPerms.electronicValidate]);
    }

    if (!isUserFormOwner || !AccessControl.hasPermission(permissions, [ActivityPerms.scannedValidate, ActivityPerms.scannedEdit])) {
      return true;
    }
    return !AccessControl.hasPermission(permissions, [ActivityPerms.scannedView, ActivityPerms.scannedValidate, ActivityPerms.scannedEdit]);
  }

  toggleOriginal(file) {
    const { originalVisible } = this.state;

    if (!originalVisible) {
      if (!file || !file.id || !file.originalFileName) {
        toastr.error('', 'There is no original pdf file stored with this form');
        return false;
      }
      this.getOriginalPdfView(file);
    } else {
      this.setState({
        originalVisible: !originalVisible,
        pdfView: null,
        validationResultsVisible: this.isValidated()
      });
    }
    return false;
  }

  openAccountWithholdingModal(accountId) {
    const { dispatch, match: { params: { formId } }, formByIdResponse } = this.props;
    if (formByIdResponse != null && (formByIdResponse.hasAllocationStatement || formByIdResponse.hasParentAccount)) {
      dispatch(showImyTreeWithholding(accountId));
    } else {
      dispatch(showAccountWithholdingModal(formId, null, null));
    }
  }

  closeAccountWithholdingModal() {
    const { dispatch } = this.props;
    dispatch(hideAccountWithholdingModal());
  }

  openFormOverrideModal() {
    const { dispatch } = this.props;
    dispatch(showFormOverrideModal());
  }

  closeFormOverrideModal() {
    const { dispatch } = this.props;
    dispatch(hideFormOverrideModal());
  }

  openCancelFormOverrideModal() {
    const { dispatch } = this.props;
    dispatch(showCancelFormOverrideModal());
  }

  closeCancelFormOverrideModal() {
    const { dispatch } = this.props;
    dispatch(hideCancelFormOverrideModal());
  }

  closeEditAddressModal() {
    const { dispatch } = this.props;
    dispatch(hideEditAddressModal());
  }

  closeWhsDiscrepanciesModal() {
    const { dispatch } = this.props;
    dispatch(hideWhsDiscrepanciesModal());
  }

  confirmWhsDiscrepanciesModal() {
    const { dispatch, match, formReviewStateParameters } = this.props;
    const { params: { formId } } = match;
    dispatch(hideWhsDiscrepanciesModal());
    dispatch(saveFormReviewState(formId, formReviewStateParameters));
  }

  renderBlank() {
    const { match: { params: { blankType } } } = this.props;
    switch (blankType) {
      case 'w8bene':
        return this.getBlankComponent(AsyncBlankBene, AsyncBlankBeneChanges);
      case 'w8bene_2017':
        return this.getBlankComponent(AsyncBlankBene2017, AsyncBlankBene2017Changes);
      case 'w8bene_2021':
        return this.getBlankComponent(AsyncBlankBene2021, AsyncBlankBene2021Changes);
      case 'w8ben':
        return this.getBlankComponent(AsyncBlankBen, AsyncBlankBenChanges);
      case 'w8ben_2014':
        return this.getBlankComponent(AsyncBlankBen2014, AsyncBlankBen2014Changes);
      case 'w8ben_2021':
        return this.getBlankComponent(AsyncBlankBen2021, AsyncBlankBen2021Changes);
      case 'w8eci_2014':
        return this.getBlankComponent(AsyncBlankEci, AsyncBlankEciChanges);
      case 'w8eci':
        return this.getBlankComponent(AsyncBlankEci2017, AsyncBlankEci2017Changes);
      case 'w8eci_2021':
        return this.getBlankComponent(AsyncBlankEci2021, AsyncBlankEci2021Changes);
      case 'w8exp_2016':
        return this.getBlankComponent(AsyncBlankExp, AsyncBlankExpChanges);
      case 'w8exp':
        return this.getBlankComponent(AsyncBlankExp2017, AsyncBlankExp2017Changes);
      case 'w8exp_2023':
        return this.getBlankComponent(AsyncBlankExp2023, AsyncBlankExp2023Changes);
      case 'w8imy':
        return this.getBlankComponent(AsyncBlankImy, AsyncBlankImyChanges);
      case 'w8imy_2017':
        return this.getBlankComponent(AsyncBlankImy2017, AsyncBlankImy2017Changes);
      case 'w8imy_2021':
        return this.getBlankComponent(AsyncBlankImy2021, AsyncBlankImy2021Changes);
      case 'w9':
        return this.getBlankComponent(AsyncBlankW9, AsyncBlankW9Changes);
      case 'w9_2017':
        return this.getBlankComponent(AsyncBlankW92017, AsyncBlankW92017Changes);
      case 'w9_2018':
        return this.getBlankComponent(AsyncBlankW92018, AsyncBlankW92018Changes);
      case 'w9_2024':
        return this.getBlankComponent(AsyncBlankW92024, AsyncBlankW92024Changes);
      case 'crse':
      case 'dt_crse':
        return this.getBlankComponent(AsyncBlankCrse, AsyncBlankCrseChanges);
      case 'ucrse_2025':
        return this.getBlankComponent(AsyncBlankUCrse2025);
      case 'crsebba':
        return this.getBlankComponent(AsyncBlankCrseBba);
      case 'crscp':
      case 'dt_crscp':
        return this.getBlankComponent(AsyncBlankCrsCp, AsyncBlankCrsCpChanges);
      case 'ucrscp_2025':
        return this.getBlankComponent(AsyncBlankUCrsCp2025);
      case 'crsi':
      case 'dt_crsi':
        return this.getBlankComponent(AsyncBlankCrsi, AsyncBlankCrsiChanges);
      case 'ucrsi_2025':
        return this.getBlankComponent(AsyncBlankUCrsi, AsyncBlankUCrsiChanges);
      case 'crsi_2024':
        return this.getBlankComponent(AsyncBlankCrsi2024, AsyncBlankCrsi2024Changes);
      case 'rc519':
        return this.getBlankComponent(AsyncBlankRc519, AsyncBlankRc519Changes);
      case 'rc518':
        return this.getBlankComponent(AsyncBlankRc518, AsyncBlankRc518Changes);
      case 'rc518_2024':
        return this.getBlankComponent(AsyncBlankRc5182024, AsyncBlankRc5182024Changes);
      case 'rc518_2025':
        return this.getBlankComponent(AsyncBlankRc5182025, AsyncBlankRc5182025Changes);
      case 'rc519_2024':
        return this.getBlankComponent(AsyncBlankRc5192024, AsyncBlankRc5192024Changes);
      case 'rc519_2025':
        return this.getBlankComponent(AsyncBlankRc5192025, AsyncBlankRc5192025Changes);
      case 'fatca_crse_2022':
        return this.getBlankComponent(AsyncBlankFatcaCrsE2022);
      case 'fatca_crse_2023':
        return this.getBlankComponent(AsyncBlankFatcaCrsE2023, AsyncBlankFatcaCrsE2023Changes);
      case 'fatca_crsi_2022':
        return this.getBlankComponent(AsyncBlankFatcaCrsI2022);
      case 'fatca_crsi_2023':
        return this.getBlankComponent(AsyncBlankFatcaCrsI2023, AsyncBlankFatcaCrsI2023Changes);
      case 'ucarfi_2026':
        return this.getBlankComponent(AsyncBlankUCarfI2026, AsyncBlankUCarfI2026Changes);
      case 'ucarfe_2026':
        return this.getBlankComponent(AsyncBlankUCarfE2026, AsyncBlankUCarfE2026Changes);
      case 'ucarfcp_2026':
        return this.getBlankComponent(AsyncBlankUCarfCp2026);
      default:
        return <div>Incorrect blank type</div>;
    }
  }

  render() {
    const {
      permissions,
      validationResult,
      match: { params: { formId, blankType } },
      isGettingFormById,
      isFetchingPdfForm,
      isFetchingPdfView,
      formByIdError,
      formByIdResponse,
      getPdfViewError,
      isValidatingForm,
      dirty,
      forms,
      workflowState,
      tinMatchFormProps,
      isEditAddressModalShown,
      isPiiProtectionEnabled,
      isWhsDiscrepanciesModalShown,
      whsFormDiscrepancies
    } = this.props;
    const { originalVisible, pdfDownload, pdfView, pdfBlocked, initialAccount } = this.state;

    const isBatchStaging = this.isWorkflowBatchStaging();
    let fileName = 'form.pdf';
    if (formByIdResponse?.originalFileName) {
      fileName = formByIdResponse.originalFileName;
    } else if (formByIdResponse?.hasSavedPdf !== true) {
      fileName = null;
    }
    const originalFile = { id: formId, originalFileName: fileName, name: fileName };
    return (
      <div>
        { (isGettingFormById || formByIdError != null) && <div className="blank-wrapper">
          <BlankPage>
            <LoadingWrapper
              loaded={ !isGettingFormById }
            >
              { formByIdError && (formByIdError.code !== 0
                ? <NotFoundPage caption="The form was not found" />
                : <div className="toast toast-error">
                  { formByIdError.message }
                </div>) }
            </LoadingWrapper>
          </BlankPage>
        </div> }

        {!isPiiProtectionEnabled && isEditAddressModalShown && <EditAddressModal
          onCancel={ () => this.closeEditAddressModal() }
          isEditAddressModalShown={ isEditAddressModalShown }
        />}

        { !isGettingFormById && formByIdError == null && blankType != null && <div
          className={ this.getWrapperClasses(blankType) }
        >
          <div className="original-section">
            { originalVisible && isFetchingPdfView && <LoadingWrapper loaded={ !isFetchingPdfView } /> }
            { originalVisible && !isFetchingPdfView && !getPdfViewError && <ScrollPdfViewer
              file={ pdfView }
            /> }
            { !isFetchingPdfView && getPdfViewError && <div className="react-pdf__message">
              <div className="viewer--error"><p>{ getPdfViewError.message != null ? getPdfViewError.message : '' }</p></div>
            </div> }
          </div>
          <div className={ this.getFormSectionClasses() }>
            <div id="form-wrapper" className="form-wrapper">
              <div id="form-content" className={ this.getFormContentClasses() }>
                { (this.isWorkflowComplete() || this.isViewOnlyForm()) && <div className="form-overlay" /> }
                { this.renderBlank() }
              </div>
            </div>
          </div>
          <FormReviewPanel
            formId={ !Number.isNaN(formId) ? parseInt(formId, 10) : null }
            accountId={ initialAccount }
            formType={ blankType }
            isOnline={ formByIdResponse != null && formByIdResponse.isOnlineForm }
            hasParentAccount={ formByIdResponse?.hasParentAccount ?? false }
            viewImyTree={ !isBatchStaging && !isGettingFormById && formByIdResponse != null
              && (formByIdResponse.hasAllocationStatement || formByIdResponse.hasParentAccount)
              && (validationResult?.formRequiresWhs ?? true) }
            viewWithholding={ !isBatchStaging && !isGettingFormById && formByIdResponse != null
              && ((!formByIdResponse.hasParentAccount && !formByIdResponse.hasAllocationStatement)
              || !(validationResult?.formRequiresWhs ?? true)) }
            isEnabled={ !isGettingFormById && !isBatchStaging }
            isLocked={ this.isLocked() }
            isCollapsed={ isGettingFormById || validationResult === null }
            className={ this.getValidationResultsSectionClasses() }
            onOpenWithholdingModal={ accountId => this.openAccountWithholdingModal(accountId) }
            onCloseWithholdingModal={ () => this.closeAccountWithholdingModal() }
            onConfirmFormOverride={ data => this.onConfirmFormOverride(data) }
            onOpenFormOverrideModal={ () => this.openFormOverrideModal() }
            onCloseFormOverrideModal={ () => this.closeFormOverrideModal() }
            onOpenCancelFormOverrideModal={ () => this.openCancelFormOverrideModal() }
            onCloseCancelFormOverrideModal={ () => this.closeCancelFormOverrideModal() }
            onCollapseExpand={ isExpanded => this.onFormReviewCollapseExpand(isExpanded) }
            tinMatchResult={ formByIdResponse && formByIdResponse.tinMatchResult }
            workflowState={ workflowState }
            isFormDirty={ dirty }
            tinMatchFormProps={ tinMatchFormProps }
            hasAllocationStatement={ formByIdResponse?.hasAllocationStatement ?? false }
          />
        </div> }

        { !formByIdError && <div className="fixed-elements">
          <div className="left-side">
            { !originalVisible && <RedirectButton
              to="/"
              title="Return back"
              className="btn-redirect-home"
              redirectBack
            /> }
            { originalVisible && <button
              type="button"
              title="Close original form"
              className="btn"
              disabled={ isGettingFormById || isFetchingPdfView || pdfBlocked }
              onClick={ () => this.toggleOriginal(pdfView) }
            >
              Close original form
            </button> }
          </div>
          <div className="center">
            { (this.isValidReviewer() && !this.isWorkflowComplete() && AccessControl.hasPermission(permissions, [ActivityPerms.scannedValidate, ActivityPerms.scannedEdit]))
              && <button
                type="button"
                form="blankForm"
                className="btn btn-primary"
                disabled={ [].includes(blankType) || isGettingFormById || this.isLocked() || isValidatingForm }
                onClick={ () => document.getElementById('dummy-validate-form-btn').click() }
              >
                Validate form
              </button> }
            { !originalVisible && formByIdResponse != null && formByIdResponse.hasSavedPdf && forms?.length === 0 && <button
              type="button"
              title="Open original form"
              className="btn"
              disabled={ isGettingFormById || isFetchingPdfView || pdfBlocked }
              onClick={ () => this.toggleOriginal(originalFile) }
            >
              { isFetchingPdfView && <span className="icon loading" /> }
              Open original form
            </button> }
            { (!originalVisible && forms?.length > 0)
              && <SplitButton title="Original Form(s)" icon="icon-share" isItemActioning={ isFetchingPdfView } onClick={ item => this.toggleOriginal(item) } items={ [originalFile, ...forms] } /> }
          </div>
          <div className="right-side">
            { formByIdResponse != null && formByIdResponse.hasSavedPdf && forms?.length === 0 && <AccessControl allowedPermissions={ [ActivityPerms.scannedDownload, ActivityPerms.electronicDownload] }>
              <a
                title="Download original PDF"
                role="button"
                tabIndex="-1"
                href={ pdfDownload }
                target="_blank"
                rel="noopener noreferrer"
                className="btn pdf-preview-link"
                onClick={ () => this.getPdfFile(originalFile) }
                disabled={ isFetchingPdfForm }
                download={ !isFetchingPdfForm && pdfDownload && (formByIdResponse && formByIdResponse.originalFileName) ? formByIdResponse.originalFileName : 'form.pdf' }
              >
                <span>
                  { !isFetchingPdfForm ? <img src="assets/images/pdf-icon.svg" alt="PDF icon" className="pdf-icon" /> : <span className="icon loading" /> }
                  Download original PDF
                </span>
              </a>
            </AccessControl>}
            { forms.length > 0 && <AccessControl allowedPermissions={ [ActivityPerms.scannedDownload, ActivityPerms.electronicDownload] }>
              <SplitButton
                title="Download PDF(s)"
                isItemActioning={ isFetchingPdfForm }
                onClick={ item => this.getPdfFile(item) }
                items={ [originalFile, ...forms] }
              />
            </AccessControl> }
          </div>
        </div> }

        { isWhsDiscrepanciesModalShown && <WhsDiscrepanciesModal
          isShown={ isWhsDiscrepanciesModalShown }
          discrepancies={ whsFormDiscrepancies }
          onConfirm={ () => this.confirmWhsDiscrepanciesModal() }
          onClose={ () => this.closeWhsDiscrepanciesModal() }
        /> }
      </div>
    );
  }
}

function getReduxFormDirtyStatus(state, ownProps) {
  let reduxFormName = '';
  if (ownProps != null && ownProps.match != null && ownProps.match.params != null && ownProps.match.params.blankType != null) {
    let formName = ownProps.match.params.blankType;
    const splitIndex = ownProps.match.params.blankType.lastIndexOf('_');
    if (splitIndex > -1) {
      formName = ownProps.match.params.blankType.substring(0, splitIndex);
    }
    reduxFormName = `${ formName }-form`;
  }
  return isDirty(reduxFormName)(state);
}

function mapStateToProps(state, ownProps) {
  const {
    auth: {
      permissions,
      settings: {
        selectedClient
      }
    },
    forms: {
      isValidatingForm,
      validationResult,
      isGettingFormById,
      isFetchingPdfForm,
      isFetchingPdfView,
      pdfFile,
      pdfDownloads,
      formByIdError,
      formByIdResponse,
      supportingDocs,
      formReviewState,
      workflowState,
      viewPdfData,
      getPdfViewError,
      instructionToggled,
      ignoreDirtyTaxForm,
      isEditAddressModalShown,
      isWhsDiscrepanciesModalShown,
      whsFormDiscrepancies,
      formReviewStateParameters
    },
    form,
    common: {
      stockMarkets
    }
  } = state;

  const dirty = getReduxFormDirtyStatus(state, ownProps);

  let tinMatchFormProps = null;

  if (form['w9-form'] !== undefined) {
    tinMatchFormProps = { tin: form['w9-form']?.values?.tin, name: form['w9-form']?.values?.name };
  }

  let forms = [];

  if (form['w8ben-form'] !== undefined && form['w8ben-form']?.values?.part2?.additionalFiles) {
    forms = form['w8ben-form'].values.part2?.additionalFiles?.filter(x => x && Object.keys(x)?.length !== 0);
  }

  if (form['w8bene-form'] !== undefined && form['w8bene-form']?.values?.part3?.additionalFiles) {
    forms = form['w8bene-form'].values.part3?.additionalFiles?.filter(x => x && Object.keys(x)?.length !== 0);
  }

  forms = forms.map(x => ({ ...x, name: x.originalFileName, isAdditional: true }));

  return {
    permissions,
    isValidatingForm,
    validationResult,
    isGettingFormById,
    isFetchingPdfForm,
    isFetchingPdfView,
    pdfFile,
    pdfDownloads,
    formByIdError,
    formByIdResponse,
    supportingDocs,
    formReviewState,
    workflowState,
    viewPdfData,
    getPdfViewError,
    instructionToggled,
    ignoreDirtyTaxForm,
    dirty,
    forms,
    tinMatchFormProps,
    isEditAddressModalShown,
    isPiiProtectionEnabled: selectedClient?.isPiiProtectionEnabled,
    stockMarkets,
    isWhsDiscrepanciesModalShown,
    whsFormDiscrepancies,
    formReviewStateParameters
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withContainerErrorBoundary(BlankContainer, 'BlankContainer'));
